export const en = {
    yandex_trip: 'Yandex Trip',
    yandex: 'Yandex',
    account_manager: 'Customer Service Manager Sergey Alentev',
    account_manager_phone: '+7 911 249-56-60',
    account_manager_telegram: 'Telegram',
};
